/* eslint-disable no-restricted-globals */ /* eslint-disable new-cap */
<template>
  <div>
    <div class="check_tool">
      <div class="check_tool__function">
        <div class="check_tool__function__load">
          <b-form-input
            v-model="target_date"
            placeholder="Date (YYYY-MM-DD)"
            class="check_tool__function__load__date"
          ></b-form-input>
          <b-button
            class="check_tool__function__load__btn"
            @click="loadFeedbackMetas()"
            >Load</b-button
          >
          <input
            type="text"
            id="input_user_id"
            style="margin-left: 24px; width: 400px"
            readonly="readonly"
            v-model="selectedUserId"
          />
          <b-button
            class="check_tool__function__load__btn"
            ref="copy"
            data-clipboard-action="copy"
            data-clipboard-target="#input_user_id"
            @click="copyUserId"
            >Copy</b-button
          >`
        </div>

        <div class="check_tool__function__paging">
          <b-container class="check_tool__function__paging">
            <b-row>
              <b-col>
                <button
                  style="width: 100px"
                  type="button"
                  @click.prevent="toggleBoxShow()"
                >
                  {{ showBox }} (ESC)
                </button>
              </b-col>
              <b-col>
                <button type="button" @click.prevent="prev()">Prev</button>
              </b-col>
              <b-col>
                <button type="button" @click.prevent="next()">Next</button>
              </b-col>
              <b-col>
                <p class="label-fun__btn--font">
                  {{ selectedIdx }}/{{ total }}
                </p>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <notifications
        group="label"
        position="top left"
        class="notice"
      ></notifications>
      <div class="check_tool__pannel">
        <b-table
          class="check_tool__pannel__list"
          ref="imgListTable"
          :busy="isLoading"
          selectable
          :sticky-header="true"
          :no-border-collapse="true"
          :select-mode="selectMode"
          :items="items"
          :fields="fields"
          @row-selected="onRowSelected"
          responsive
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>

        <sleepResultPanel
          :PropsSleepResult="PropsSleepResult"
          :ProbsItem="ProbsItem"
          :PropsEnableVisualize="PropsEnableVisualize"
        ></sleepResultPanel>
      </div>
      <imageCanvas
        v-on:image-loaded="detectSleep"
        v-on:image-not_found="noImage"
        :probImageSource="sourceType"
        :probsItem="ProbsItem"
        :probsBoxes="probsDetectBoxes"
        :probsToggleBoxShow="showBox"
      ></imageCanvas>
    </div>
  </div>
</template>

<script>
// import models
import client from "@/api/client";
import sleepResultPanel from "@/components/checktool/sleepResultPanel.vue";
import imageCanvas from "@/components/checktool/ImageCanvas.vue";

export default {
  components: { sleepResultPanel, imageCanvas },
  data() {
    return {
      sourceType: "prod", // prod is include device update data
      store_type: "alert",
      loader: null,
      // input
      target_date: "",

      // fields: [{key: 'name', stickyColumn: true, variant: 'primary' },
      fields: ["name", "reason"],
      items: [],
      selectMode: "single",
      selected: [],
      selectedUserId: "",
      selectedIdx: 0,
      isLoading: false,

      // function
      showBox: "Hide",
      current: 0,
      total: 0,

      // use in canvas
      ProbsItem: null,
      PropsSleepResult: null,
      PropsEnableVisualize: false,
      probsDetectBoxes: [],
    };
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading;
    },
    copyUserId() {
      const vm = this;
      const clipboard = this.copyBtn;
      clipboard.on("success", (e) => {
        /* vm.$bvToast.toast('Copied !!', {
          toaster: 'b-toaster-top-center',
          solid: false,
          appendToast: false,
          autoHideDelay: 2000,
        }); */
        console.log("Copy!!");
        e.clearSelection();
      });
    },
    toggleBoxShow() {
      if (this.items.length === 0) return;
      if (this.showBox === "Hide") {
        this.showBox = "Show";
      } else {
        this.showBox = "Hide";
      }
    },
    loadFeedbackMetas() {
      const vm = this;
      this.toggleLoading();

      const params = {
        date: this.target_date,
        data_type: "sleep",
      };
      client.get("/feedback/user", params).then((res) => {
        if (res === 401) {
          vm.$router.push("/login");
        } else {
          vm.items = [];
          res.metas.forEach((item) => {
            // parse respone from feedback bigtable
            // eslint-disable-next-line no-useless-escape
            const filename = item.image.replace(/^.*[\\\/]/, "");
            const userId = item.image.split("/")[4];
            const date = item.image.split("/")[7];

            const meta = {
              name: filename,
              device_id: item.device_id,
              alert_id: item.alert_id,
              user_id: userId,
              date,
              reason: item.reason,
            };

            // parse detection zone
            let detectZone = [];
            // eslint-disable-next-line no-const-assign
            const parsedParams = vm.parseParams(item.params);
            if ("detection_zone_area" in parsedParams) {
              const dzone = parsedParams.detection_zone_area;
              detectZone = [dzone.x_min, dzone.y_min, dzone.x_max, dzone.y_max];
              meta.detect_zone = detectZone;
            }
            vm.items.push(meta);
          });
          vm.toggleLoading();
          vm.selectRow(0);
          vm.total = vm.items.length;
        }
      });
    },
    detectSleep(item) {
      const vm = this;
      const key = `${item.user_id}/${item.device_id}/alert/${item.date}/${item.name}`;
      const body = {
        bucket_type: "prod",
        key,
        detect_zone: item.detect_zone,
      };
      client.post("/test/sleep", null, body).then((res) => {
        console.log(res);
        // put detect_zone to detect results (if has)
        if ("detect_zone" in item) {
          res.results.push({ description: "roi", bbox: item.detect_zone });
        }
        vm.probsDetectBoxes = res.results;
        vm.PropsSleepResult = res;
        if (res.posture !== "Y" && res.posture !== "X") {
          this.PropsEnableVisualize = true;
        } else {
          this.PropsEnableVisualize = false;
        }
        this.loader.hide();
      });
    },
    noImage() {
      const vm = this;
      // vm.toggleLoading();
      this.loader.hide();
      console.log("image canvas load image fail!!");
    },
    onRowSelected(item) {
      // load image by ImageCanvas
      this.ProbsItem = item[0];
      this.selectedUserId = item[0].user_id;
      // this.loadImage(item[0])
      this.selected = item;
      this.selected[0].store_type = this.store_type;
      if (this.loader != null) {
        this.loader.hide();
        this.loader = null;
      }
      this.loader = this.$loading.show();

      // get item index
      let index = 0;
      let i = 0;
      for (; i < this.items.length; i += 1) {
        if (this.items[i].name === item[0].name) {
          index = i;
          break;
        }
      }
      this.selectedIdx = index;
    },
    async selectRow(idx) {
      await 500;
      this.$refs.imgListTable.selectRow(idx);
    },
    parseParams(params) {
      let paramStr = params.substring(1, params.length - 1);
      paramStr = paramStr.replace(/\\/g, "");
      paramStr = paramStr.substring(1, paramStr.length - 1);
      return JSON.parse(paramStr);
    },
    next() {
      const vm = this;
      if (vm.selectedIdx < vm.items.length - 1) {
        vm.selectedIdx += 1;
        vm.selectRow(vm.selectedIdx);
      }
    },
    prev() {
      const vm = this;
      if (vm.selectedIdx > 0) {
        vm.selectedIdx -= 1;
        vm.selectRow(vm.selectedIdx);
      }
    },
  },
  mounted() {
    const vm = this;
    this.copyBtn = new this.clipboard(this.$refs.copy);

    vm.target_date = new Date().toISOString().slice(0, 10);

    document.onkeydown = function onKeyDown(e) {
      switch (e.code) {
        case "ArrowRight":
        case "ArrowDown":
          vm.next();
          break;
        case "ArrowLeft":
        case "ArrowUp":
          vm.prev();
          break;
        case "Escape":
          vm.toggleBoxShow();
          break;
        default:
          break;
      }
    };
  },
};
</script>
